import Cookies from 'js-cookie';

import { LOCALES, NEXT_LOCALE_COOKIE_NAME } from 'localization/constants/configEnums';

// Get Locale from the current url
export const getRouterLocale = () => {
  const localeFromCookie = Cookies.get(NEXT_LOCALE_COOKIE_NAME);

  return localeFromCookie || LOCALES.enUS;
};
